import { WebToNativeMessage } from '../../Common/Utils.js';
import {
    getProfileData,
    getQuizCategoriesData,
    getLinkBankAccont,
    verifyIFSCCode,
    getRedeemDetails,
    getWithdrawRequest,
    verifyMobile,
    cancleWithdrawRequest,
    getTranscationSummeryDetails,
    deleteWallet,
    getWalletTypeData,
    getRedeemHistory,
    getRedeemAcePointsData,
    claimRedeemAcePoints,
    getUPIData,
    getRemoveUPIData,
    getFailedTranscationsData,
    getRecheckTranscationsData,
    getDelinkBankAccount,
    getBonusSummeryData,
    getTPSLRecheckTranscationsData,
    getRazorpayRecheckTranscationsData,
    getUserAmountTDSInfo,
    PokerAmountToA23Transfer,
    A23ToPokerAmountTransfer,



} from '../../Services/userService.js';


export const getUserProfileAction = (token) => async dispatch => {
    console.log("Debug log invoking 44444 get profile data");
    const profileData = await getProfileData(token);
    console.log("data in profiledata",profileData);
    const responsedata = await profileData.data;
    console.log("jsondata in profiledata::",responsedata);
    if (responsedata.errors) {
       WebToNativeMessage( {"type": "trackTime" , "pageName" : "wallet page error"})
        dispatch({
            type: "profile_error",
            payload: responsedata.errors[0].message
        })
    } else {
        WebToNativeMessage( {"type": "trackTime" , "pageName" : "wallet page"})
        dispatch({
            type: "profile_data",
            payload: responsedata
        })
    }
}

export const getQuizData = (token) => async dispatch => {
    const responseData = await getQuizCategoriesData(token);
    // console.log("data in Quizcategeries",responseData);
    const quizData = await responseData.data;
    // console.log("Quiz Data::::",quizData);
    dispatch({
        type: "Quiz_data",
        payload: quizData
    })
}


export const getBankDetailsStatus = (token, accountNum, acountName, ifscCode) => async dispatch => {

    const responseData = await getLinkBankAccont(token, accountNum, acountName, ifscCode);
    // console.log("Get Bank Details::::Data",responseData);
    const bankDetailsDataResponse = await responseData.data;
    // console.log("Bank response Data:",bankDetailsDataResponse);
    dispatch({
        type: "BANK_DATA",
        payload: bankDetailsDataResponse
    })
}

export const verifyIFSCCodeDetails = (token, paramsdata) => async dispatch => {
    const responseData = await verifyIFSCCode(token, paramsdata);
    // console.log("Get IFSC Details::::Data",responseData);
    const ifscValidationResponse = await responseData.data;
    // console.log("IFSC reaponse Data:",ifscValidationResponse);
    dispatch({
        type: "IFSC_DATA",
        payload: ifscValidationResponse
    })
}

export const toggleAlertAction = (toggleAlertStatus, errMsg, duration, color) => (dispatch) => {
    dispatch({
        type: "TOGGLE_ALERT",
        payload: { toggleAlertStatus, errMsg, duration, color }
    })
}


export const toggleModalAction = (toggleStatus, component, dismiss) => (dispatch) => {
    dispatch({
        type: "TOGGLE_MODAL",
        payload: { toggleStatus, component, dismiss }
    })
}

//For Getting Redeem_detais Api Action
export const getRedeemDetailsAction = (token) => async dispatch => {
    const redeemData = await getRedeemDetails(token);
    // console.log("data in redeemData",redeemData);
    const responsedata = await redeemData.data;
    // console.log("jsondata in redeemData::",responsedata);
    dispatch({
        type: "redeem_data",
        payload: responsedata
    })

}

//For Redeem Withdraw Action
export const getWithdrawRequestAction = (token, amount, w_type, w_channel, w_value, w_name) => async dispatch => {
    const withdrawrequestData = await getWithdrawRequest(token, amount, w_type, w_channel, w_value, w_name);
    // console.log("data withdrawrequest ",withdrawrequestData);
    const responsedata = await withdrawrequestData.data;
    // console.log("jsondata in withdrwa::",responsedata);
    dispatch({
        type: "withdraw_data",
        payload: responsedata
    })
}

export const getLinkAccountInfo = (token, mobile, otp, otpTemplate) => async dispatch => {
    const linkData = await verifyMobile(token, mobile, otp, otpTemplate);
    console.log("data in linkaccount", linkData);
    const responsedata = await linkData.data;
    // console.log("jsondata in linkaccount::", responsedata);
    dispatch({
        type: "link_data",
        payload: responsedata
    })
}

//For Redeem cancle Withdraw Request
export const getCancleWithdrawAction = (w_token, w_tnxId, w_channel,w_location) => async dispatch => {
    const canclewithdrawData = await cancleWithdrawRequest(w_token, w_tnxId, w_channel,w_location);
    // console.log("data in linkaccount", canclewithdrawData);
    const responsedata = await canclewithdrawData.data;
    // console.log("jsondata in linkaccount::", responsedata);

    dispatch({
        type: "cancle_withdraw_data",
        payload: responsedata
    })

}

//For Transcaton Summery Request :

export const getTransactionSummary = (ts_token, ts_numberofdays, ts_transactionType, ts_userid) => async dispatch => {
    const transcationSummeryData = await getTranscationSummeryDetails(ts_token, ts_numberofdays, ts_transactionType, ts_userid);
    // console.log("TS Data", transcationSummeryData);
    // console.log("TS DATA TOKEN: ", ts_token)
    console.log("TS DATA DAYS: ", ts_numberofdays)
    console.log("TS DATA TYPE: ", ts_transactionType)
    console.log("TS DATA USERID: ", ts_userid)
    // console.log("TS DATA APPTYPE: ", ts_appType)
    const responsedata = await transcationSummeryData.data;
    // console.log("jsondata in TS DATA::", responsedata);
    dispatch({
        type: "transcations_data",
        payload: responsedata
    })
}

export const getDeleteAccountStatus = (w_token, w_type, w_channel) => async dispatch => {
    //const deleteWalletData = await deleteWallet(w_token,w_type,w_otp);
    const deleteWalletData = await deleteWallet(w_token, w_type, w_channel);
    // console.log("TS Data", deleteWalletData);
    const responsedata = await deleteWalletData.data;
    // console.log("jsondata in Delete Wallet DATA::", responsedata);
    dispatch({
        type: "delete_wallet",
        payload: responsedata
    })
}

export const getWalletTypeInfo = (token, wallettype, channel, otp) => async dispatch => {
    const walletTypeData = await getWalletTypeData(token, wallettype, channel, otp);
    console.log("WALLET TYPE INFO DATA", walletTypeData);
    const responsedata = await walletTypeData.data;
    // console.log("jsondata in walletType::", responsedata);
    dispatch({
        type: "wallet_type_data",
        payload: responsedata
    })
}

export const getRedeemHistoryAction = (token) => async dispatch => {
    const redeemHistoryData = await getRedeemHistory(token);
    // console.log("data in redeemHistory", redeemHistoryData);
    const responsedata = await redeemHistoryData.data;
    // console.log("jsondata in walletType::", responsedata);
    dispatch({
        type: "redeem_history",
        payload: responsedata
    })
    return responsedata
}


export const fetchRedeemAcePointsData=(token)=> async dispatch=>{
    console.log("Debug log invoking get redeem ace points data");
    const redeemAcePointsPromise = await getRedeemAcePointsData(token)
    const responseData = await redeemAcePointsPromise.data
    dispatch({
        type:"redeem_ace_points_details",
        payload: responseData
    })
    
}


export const submitClaimRedeemAcePoints =  (token,requestObject)=>async dispatch => {
    const  claimPromise =await claimRedeemAcePoints(token,requestObject)
    const claimSuccessMessage = await claimPromise.data.response
    console.log(claimSuccessMessage,claimPromise)
    dispatch({
        type:"redeem_ace_points_claim_success",
        payload:claimSuccessMessage
    })
    return claimSuccessMessage
}


export const getUPIInfo = (upi, confirmupi, otp, token, value, channel) => async dispatch => {
    const upiData = await getUPIData(upi, confirmupi, otp, token, value, channel);
    console.log("data of upi::", upiData);
    const responsedata = await upiData.data;
    // console.log("jsondata in upi::", responsedata);
    dispatch({
        type: "upi_data",
        payload: responsedata
    })
}

//Remove UPI Info API
export const getRemovedUPIData = (token, upiId, channel) => async dispatch => {
    const removeupiData = await getRemoveUPIData(token, upiId, channel);
    // console.log("data of upi::", removeupiData);
    const responsedata = await removeupiData.data;
    // console.log("jsondata in upi::", responsedata);
    dispatch({
        type: "remove_upi",
        payload: responsedata
    })
}

//Added Redeem failed transcations Data
export const getFailedTranscatiosData = (token, ts_userid) => async dispatch => {
    const failedTranscationsData = await getFailedTranscationsData(token, ts_userid);
    // console.log("data in failedTransctions Api", failedTranscationsData);
    const responsedata = await failedTranscationsData.data;
    // console.log("Data:::failed Transcations", responsedata);
    dispatch({
        type: "failed_transcations_history",
        payload: responsedata
    })
}

//Added Recheck failed transcation Action 
export const getRecheckFailedTranscatiosData = (token, order_id) => async dispatch => {
    const recheck_trnx_data = await getRecheckTranscationsData(token, order_id);
    // console.log("data in Recheck failedTransctions Api", recheck_trnx_data);
    const responsedata = await recheck_trnx_data.data;
    // console.log("Data:::failed Recheck Transcations", responsedata);
    dispatch({
        type: "recheck_transcation",
        payload: responsedata
    })
}


//Added Recheck failed transcation Action 
export const getRemoveBankAccount = (token, account_number) => async dispatch => {
    const removeBankAccountRes = await getDelinkBankAccount(token, account_number);
    // console.log("data in Delete Bank Account Api", removeBankAccountRes);
    const responsedata = await removeBankAccountRes.data;
    // console.log("Data:::Delete Bank Account Api ", responsedata);
    dispatch({
        type: "delink_bankAccount",
        payload: responsedata
    })
}

//Added BonusSummeryAction


export const getBonusSummery = (token, bs_userid) => async dispatch => {
    const bonusSummeryResponse = await getBonusSummeryData(token, bs_userid);
    // console.log(":::BonusSummeryData", bonusSummeryResponse);
    const responsedata = await bonusSummeryResponse.data;
    // console.log("SB:::Data:::BonusSummeryApi ", responsedata);
    dispatch({
        type: "bonus_summery",
        payload: responsedata
    })
}

export const networkStatus = (status) => (dispatch) => {
    dispatch({
        type: "network_status",
        networkStatus: status
    })
}

export const updateAppVisibility = (status) => (dispatch) => {
    dispatch({
        type: "UPDATE_VISIBILITY",
        appHidden: status
    })
}

//TPSL TRANSCATION RECHECK ACTION
export const getTpslRecheckFailedTranscatiosData = (token, order_id, pgChannel) => async dispatch => {
    const recheck_trnx_data = await getTPSLRecheckTranscationsData(token, order_id, pgChannel);
    // console.log("data in Tpsl Recheck failedTransctions Api", recheck_trnx_data,pgChannel);
    const responsedata = await recheck_trnx_data.data;
    // console.log("Data:::Tpsl failed Recheck Transcations", responsedata);
    dispatch({
        type: "tpsl_recheck_transcation",
        payload: responsedata
    })
}

//Razorpay Transaction Recheck Action
export const getRazorpayRecheckData = (token, order_id, pgChannel) => async dispatch => {
    const recheck_tnx_data = await getRazorpayRecheckTranscationsData(token, order_id, pgChannel);
    // console.log("data in RazorPay Recheck failedTransctions Api", recheck_tnx_data,pgChannel);
    const responsedata = await recheck_tnx_data.data;
    // console.log("Data:::Razorpay failed Recheck Transcations", responsedata);
    dispatch({
        type: "razorpay_recheck_transcation",
        payload: responsedata
    })
}

//Poker Related API's

//Razorpay Transaction Recheck Action
export const getPokerAmountTDSInfo = (token, gameId, pk_depositAmount, pk_mode, timeStamp, pk_amount, pk_winAmount, playerName, pk_extraCashAmount, pk_promoAmount, pk_sessionToken, currencyCode) => async dispatch => {
    // console.log("Poker TDS Info Action",token,gameId,pk_depositAmount,pk_mode,timeStamp,pk_amount,pk_winAmount,playerName,pk_extraCashAmount,pk_promoAmount,pk_sessionToken,currencyCode);
    const tds_info_data = await getUserAmountTDSInfo(token, gameId, pk_depositAmount, pk_mode, timeStamp, pk_amount, pk_winAmount, playerName, pk_extraCashAmount, pk_promoAmount, pk_sessionToken, currencyCode);
    // console.log("Poker TDS Info API Data 4", tds_info_data);
    const responsedata = await tds_info_data.data;
    // console.log("Poker TDS Response 5", responsedata);
    dispatch({
        type: "tds_info",
        payload: responsedata
    })
}


export const pokerAmountToA23Transfer = (token, pk_ConversionType) => async dispatch => {
    const PokerToA23 = await PokerAmountToA23Transfer(token, pk_ConversionType);
    // console.log("Poker To A23 Info API Data", PokerToA23);
    const responsedata = await PokerToA23.data;
    // console.log("Poker To A23 Response", responsedata);
    dispatch({
        type: "pokerToA23",
        payload: responsedata
    })
}


export const a23ToPokerAmountTransfer = (token, pk_ConversionType, pk_amount) => async dispatch => {
    const A23ToPoker = await A23ToPokerAmountTransfer(token, pk_ConversionType, pk_amount);
    // console.log("A23 To Poker 01", A23ToPoker);
    const responsedata = await A23ToPoker.data;
    // console.log("A23 To POKER 02", responsedata);
    dispatch({
        type: "a23ToPoker",
        payload: responsedata
    })
}


